import React from 'react'
import PropTypes from 'prop-types'

export default class RiskAssessmentSortType extends React.Component {
  state = {
    changedSort: undefined,
  }

  handleChange = (e) => {
    const { onChange } = this.props
    const type = e.target.value
    this.setState({ changedSort: type })
    onChange(null)
    onChange(type)
  }

  render() {
    const { params, sortType, style } = this.props
    return (
      <select
        className="lmc-handover-select"
        style={{ ...style, ...styles.select }}
        value={sortType || this.state.changedSort}
        onChange={this.handleChange}
      >
        <option value="recent">Most recent</option>
        <option value="high-low">Risk (descending)</option>
        <option value="low-high">Risk (ascending)</option>
        {params && !params.risk_assessment_id && (
          <option value="a-z">A-Z</option>
        )}
      </select>
    )
  }
}

const styles = {
  select: {
    border: 'none',
    background: 'inherit',
    cursor: 'pointer',
    fontWeight: 600,
    textAlign: 'right',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
  },
}

RiskAssessmentSortType.propTypes = {
  onChange: PropTypes.func.isRequired,
  sortType: PropTypes.string,
  style: PropTypes.object,
}
